module.exports = __webpack_public_path__ + "media/images/landing/main_bubles_m-4da8e204335c9d6f064af138a8371eab.svg";